export function argOrDefault<T>(defaultValue: T): PropertyDecorator {
  return (_target: unknown, propertyKey: string | symbol) => {
    return {
      get(this: { args: Record<string, T> }): T {
        const value = this.args[propertyKey as string];
        return value ?? defaultValue;
      }
    };
  };
}
